import { jsx as _jsx } from "react/jsx-runtime";
// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { WMComponent } from '@front/webmobile/Views/Components/WMComponent';
import React from 'react';
import { QuickTreeReact } from './QuickTreeReact';
import { TextBox } from '../../elements/TextBox';
import { Checkbox } from '@components/webdesktop/elements/Checkbox/Checkbox';
import { FormLabel } from '@components/webdesktop/elements/FormLabel/FormLabel';
export class LookupDropDownForm extends WMComponent {
    constructor(props, viewModel) {
        super(props, viewModel);
        this.onMultiSelectCheckboxClick = (event) => {
            this.viewModel.onMultiSelectCheckboxClick(event.currentTarget.checked);
        };
        this.onQuickTreeDoubleClick = this.onQuickTreeDoubleClick.bind(this);
        this.onQuickTreeEnterPress = this.onQuickTreeEnterPress.bind(this);
        this.onTextBoxValueChanged = this.onTextBoxValueChanged.bind(this);
        this.onSelectionChanged = this.onSelectionChanged.bind(this);
        this.onQuickTreeCreated = this.onQuickTreeCreated.bind(this);
        this.onKeyDown = this.onKeyDown.bind(this);
        this.onAfterMouseDown = this.onAfterMouseDown.bind(this);
        this.subscribeOnResize = this.subscribeOnResize.bind(this);
        this.unsubscribeOnResize = this.unsubscribeOnResize.bind(this);
        this.handleGlobalClick = this.handleGlobalClick.bind(this);
        this.onClose = this.onClose.bind(this);
        this.mainContainerRef = React.createRef();
    }
    componentDidMount() {
        super.componentDidMount();
        document.addEventListener('click', this.handleGlobalClick);
    }
    componentWillUnmount() {
        super.componentWillUnmount();
        document.removeEventListener('click', this.handleGlobalClick);
    }
    onClose() {
        this.viewModel.close();
    }
    handleGlobalClick(event) {
        if (!this.props.autoClose) {
            return;
        }
        if (this.mainContainerRef.current && !this.mainContainerRef.current.contains(event.target)) {
            this.onClose();
        }
    }
    onQuickTreeEnterPress() {
        this.viewModel.onEnterPressed();
    }
    onQuickTreeDoubleClick() {
        this.viewModel.onQuickTreeDoubleClick();
    }
    onTextBoxValueChanged(value) {
        this.viewModel.onTextBoxValueChanged(value);
    }
    onSelectionChanged() {
        this.viewModel.selectionChanged();
    }
    onQuickTreeCreated(quickTree) {
        this.viewModel.onQuickTreeCreated(quickTree);
    }
    subscribeOnResize(callback) {
        this.viewModel.subscribeOnResizeQuickTree(callback);
    }
    unsubscribeOnResize(callback) {
        this.viewModel.unsubscribeOnResizeQuickTree(callback);
    }
    onKeyDown() { }
    onAfterMouseDown() { }
    render() {
        const { x, y } = this.state;
        const { width, height } = this.props;
        const style = {
            left: x,
            top: y,
            width,
            height
        };
        return (_jsx("div", { ref: this.mainContainerRef, className: "lookup-drop-down-form-wrapper", style: style, children: this.renderDropDownForm() }));
    }
    renderDropDownForm() {
        return null;
    }
    renderQuickTree(boldRootNode = false) {
        const { isMultiSelectCheckboxUsing } = this.props;
        const { isMultiSelect } = this.state;
        return (_jsx(QuickTreeReact, { UseCHBox: isMultiSelectCheckboxUsing, isMultiSelect: isMultiSelect, onEnterPress: this.onQuickTreeEnterPress, onDoubleClick: this.onQuickTreeDoubleClick, onSelection: this.onSelectionChanged, onQuickTreeCreated: this.onQuickTreeCreated, onKeyDown: this.onKeyDown, onAfterMouseDown: this.onAfterMouseDown, boldRootNode: boldRootNode, subscribeOnResize: this.subscribeOnResize, unsubscribeOnResize: this.unsubscribeOnResize }));
    }
    renderMultiSelectCheckbox() {
        if (!this.props.isMultiSelectMode) {
            return null;
        }
        const { isMultiSelect, multiSelectText } = this.state;
        return (_jsx(FormLabel, { label: multiSelectText, children: _jsx(Checkbox, { checked: isMultiSelect, onChange: this.onMultiSelectCheckboxClick }) }));
    }
    renderTextBox(additionalClass) {
        return (_jsx(TextBox, { additionalClass: additionalClass, onChange: this.onTextBoxValueChanged, text: this.state.textBoxValue, placeholder: this.state.textBoxPlaceholder, svgIcon: "search" }));
    }
}
LookupDropDownForm.defaultProps = {
    isCentered: false,
    autoClose: true,
    isOptionMasterMode: false,
    isMultiSelectMode: false,
    isMultiSelectCheckboxUsing: false,
    isShowSelectAll: false,
    showButtons: false
};
